module.exports = __webpack_public_path__ + "static/media/icon-football.6262caec.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-football.svg
// module id = ./src/assets/images/icon-football.svg
// module chunks = 0